export enum Country {
    NETHERLANDS = 'NL',
    BELGIUM = 'BE',
    FRANCE = 'FR',
    GERMANY = 'DE',
}
